import {
  withButtonAlignment,
  withRtlSupport,
} from '@skyscanner-internal/backpack-web/bpk-component-icon';
import BpkSmallChevronRightIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/chevron-right';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import reactReplacePlaceholder from 'react-replace-placeholder';

import type { NearbyAirportsStrings } from '@skyscanner-internal/landing-pages-shared-types/types-shared/NearbyAirportsProps';

import STYLES from './MobilePriceSection.module.scss';

type MobilePriceSectionProps = {
  formattedPrice: string | null;
  strings: NearbyAirportsStrings;
};

const AlignedChevron = withButtonAlignment(
  withRtlSupport(BpkSmallChevronRightIcon),
);

const MobilePriceSection = (props: MobilePriceSectionProps) => {
  const { formattedPrice, strings } = props;

  return (
    <div className={STYLES.MobilePriceSection}>
      {formattedPrice && (
        <div className={STYLES.fromPrice}>
          <BpkText
            className={STYLES.fromPriceText}
            textStyle={TEXT_STYLES.label1}
          >
            {reactReplacePlaceholder(
              strings['component_airports-from-price'],
              { price: formattedPrice },
              '{',
              '}',
            )}
          </BpkText>
        </div>
      )}
      <div className={STYLES.search}>
        <BpkText textStyle={TEXT_STYLES.heading5}>
          {strings['component_airports-search-flights']}
        </BpkText>
        <span className={STYLES.arrow}>
          <AlignedChevron />
        </span>
      </div>
    </div>
  );
};

export default MobilePriceSection;
